import React, { useMemo, useState } from 'react';

import { MobilePaymentStatus, PaymentApprovalError } from '../models';
import { SigningContext } from './SigningContext';

export const SigningContextProvider = ({ children }: React.PropsWithChildren) => {
    const [status, setStatus] = useState<MobilePaymentStatus>();

    const [error, setError] = useState<PaymentApprovalError>();

    const value = useMemo(
        () => ({
            status,
            setStatus,
            error,
            setError,
        }),
        [error, status],
    );

    return <SigningContext.Provider value={value}>{children}</SigningContext.Provider>;
};
